// 超级管理员
export const SUPER_ADMIN = 'super_admin';